'use strict';

export default class OauthLoginController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  submitted = false;
  AuthSvc;
  OauthSvc;
  $state;

  constructor($http, $state, $cookies, $window, ToastrSvc,
    AuthSvc, UserSvc, OauthSvc, LoaderSvc) {
    this.$http = $http;
    this.$state = $state;
    this.$window = $window;
    this.ToastrSvc = ToastrSvc;
    this.AuthSvc = AuthSvc;
    this.OauthSvc = OauthSvc;
    this.LoaderSvc = LoaderSvc;

    var that = this;
    that.authorizeRedirect = function(authorizationCode, email, fname) {
      var queryString = that.$state.params;
      queryString.code = authorizationCode;

      // temporary test w/ email and fname
      queryString.email = email;
      queryString.fname = fname;

      // convert dashes so that uri is handled properly in state params
      that.OauthSvc.checkOk().$promise
        .then(res => {
          var hasAuthorizedOAuth = res.hasAuthorizedOAuth;
          if(hasAuthorizedOAuth) {
            var url = queryString.redirect_uri;
            queryString = Object.keys(queryString)
              .map(key => key + '=' + queryString[key])
              .join('&');
            url += '?' + queryString;
            that.$window.location.href = url;
          } else {
            queryString.redirect_uri.replace('/', '%2F');
            that.$state.go('oauthauthorize', queryString);
          }
        });
    };

    // redirect to main if already logged in
    that.LoaderSvc.start();
    AuthSvc.isLoggedIn(function(loggedIn) {
      if(loggedIn) {
        AuthSvc.getCurrentUser(function() {
          that.OauthSvc.authorize({
            // email: this.user.email,
            // password: this.user.password,
            grant_type: 'authorization_code', // eslint-disable-line
            client_id: that.$state.params.client_id, // eslint-disable-line
            state: that.$state.params.state,
            response_type: 'code' // eslint-disable-line
            // client_secret: 'testClientSecret'
          }).$promise
            .then(res => {
              that.LoaderSvc.stop();
              that.authorizeRedirect(res.authorizationCode, res.user.email,
                res.user.fname);
            })
            .catch(err => {
              that.LoaderSvc.stop();
              var msg = err.message;
              if(!msg && err.data) { msg = err.data.message; }
              that.submitted = true;
              that.ToastrSvc.error(msg);
            });
        });
      } else {
        that.LoaderSvc.stop();
      }
    });
  }

  login(form) {
    this.submitted = true;
    var that = this;
    if(form.$valid) {
      that.LoaderSvc.start();
      that.OauthSvc.authorizeLogin({
        email: this.user.email,
        password: this.user.password,
        grant_type: 'authorization_code', // eslint-disable-line
        client_id: that.$state.params.client_id, // eslint-disable-line
        state: that.$state.params.state,
        response_type: 'code' // eslint-disable-line
        // client_secret: 'testClientSecret'
      }).$promise
        .then(res => {
          // login to app for auth purposes
          that.AuthSvc.login({
            email: that.user.email,
            password: that.user.password
          })
            .then(() => {
              that.LoaderSvc.stop();
              that.authorizeRedirect(res.authorizationCode, res.user.email,
                res.user.fname);
            });
        })
        .catch(err => {
          that.LoaderSvc.stop();
          var msg = err.message;
          if(!msg && err.data) { msg = err.data.message; }
          that.submitted = true;
          that.ToastrSvc.error(msg);
        });
    }
  }
}
